import { Instance, types } from 'mobx-state-tree';
import { withSetPropAction } from 'src/models/extensions/withSetPropAction';
import { OperatorInfo } from 'src/models/operator-info/OperatorInfo';

// 각 에디터의 컨텐츠와 스타일 데이터
const EditorContent = types.model('EditorData').props({
  shapes: types.optional(types.array(types.frozen()), []),
  assets: types.optional(types.array(types.frozen()), []),
});

// 에디터 모드: 디바이스별 데이터
const DeviceEditorData = types.model('DeviceEditorData').props({
  desktop: types.optional(EditorContent, {}),
  tablet: types.optional(EditorContent, {}),
  mobile: types.optional(EditorContent, {}),
});

// 메인 비주얼 모델
export const MainVisual = types
  .model('MainVisual')
  .props({
    visualSid: types.number,
    useYn: types.optional(types.boolean, true),
    delYn: types.optional(types.boolean, false),
    ordr: types.maybeNull(types.number),
    langCd: types.maybeNull(types.string),
    regUser: types.maybeNull(OperatorInfo),
    updUser: types.maybeNull(OperatorInfo),
    regDt: types.optional(types.maybeNull(types.number), 0),
    updDt: types.optional(types.maybeNull(types.number), 0),
    // 컨텐츠
    mainText: types.optional(types.string, ''),
    subText: types.optional(types.string, ''),
    mainTextColor: types.optional(types.string, '#000'),
    subTextColor: types.optional(types.string, '#000'),
    bgPath: types.optional(types.array(types.string), []),
  })
  .volatile(() => ({
    files: [] as File[],
    deleteFilesPath: [] as string[],
  }))
  .actions(withSetPropAction);

// 타입 정의
type TMainVisual = Instance<typeof MainVisual>;
type TEditorContent = Instance<typeof EditorContent>;
type TDeviceEditorData = Instance<typeof DeviceEditorData>;

// 인터페이스 export
export interface IMainVisual extends TMainVisual {}
export interface IEditorContent extends TEditorContent {}
export interface IDeviceEditorData extends TDeviceEditorData {}

export const createMainVisual = () =>
  types.optional(MainVisual, {
    visualSid: 0,
    useYn: true,
    delYn: false,
    ordr: null,
    langCd: null,
    regUser: null,
    updUser: null,
    regDt: null,
    updDt: null,
    mainText: '',
    subText: '',
    mainTextColor: '#000',
    subTextColor: '#000',
    bgPath: [],
  });
